interface NavBarBrandProps {
  image: string;
  name?: string;
}

const NavBarBrand = ({ image, name }: NavBarBrandProps) => (
  <div className="navbar-brand">
    <span className="navbar-brand__image">
      <img className="d-inline-block align-top" data-testid="navigation-brand-image" src={image} alt={name} />
    </span>
    {name && <span className="navbar-brand__name">{name}</span>}
  </div>
);

export default NavBarBrand;
